// This function selects the suggested size
function confirmSize(event) {

	// Use window.sizingProduct instead of product to avoid variable redeclaration
	const variant = product.variants.find((v) => v.id == event.detail.code);
  
	  if (!variant) return;
	  variant.options.forEach((optionValue, index) => {
		  const optionName = product.options[index];
		  const escapedOptionValue = CSS.escape(optionValue);
		  const selector = `[name^="${optionName}"][value="${escapedOptionValue}"]`;
		  const element = document.querySelector(selector);
		  element?.click();
  
	  });
  };
  
  const widget = document.querySelector('#onlinesizing-widget');
  widget?.addEventListener('select', confirmSize);